export default class CardIcon extends HTMLElement {
    constructor(){
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.data = JSON.parse(this.getAttribute('data'));
        this.icon = this.getAttribute('icon');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#card-icon');
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });
        this.instance.querySelector('[name="text-top"]').innerHTML = this.data.textTop;
        this.instance.querySelector('[name="text-bottom"]').innerHTML = this.data.textBottom;
        this.instance.querySelector('[name="text-right"]').innerHTML = this.data.textRight;
        this.instance.querySelector('[data-entity="icon"]').classList.add(this.icon);
        this._shadowRoot.appendChild(this.instance);
    }
}